import { Link } from "react-router-dom";
import IMG1 from "../assets/about_img.jpg";

export default function AboutSection() {
  return (
    <section className="my-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-12 glassmorphism rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-main/10 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute top-10 right-10 w-40 h-40 bg-accent/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="w-full md:w-1/2 relative group">
          <div className="absolute inset-0 bg-gradient-to-tr from-main to-accent rounded-2xl transform translate-x-3 translate-y-3 transition duration-500 group-hover:translate-x-5 group-hover:translate-y-5"></div>
          <img
            src={IMG1}
            className="relative z-10 w-full h-auto rounded-2xl shadow-xl object-cover transform transition duration-500 group-hover:-translate-y-2 group-hover:-translate-x-2"
            alt="pandit maheshdas"
          />
        </div>

        <div className="w-full md:w-1/2 flex flex-col justify-center relative z-10">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-1 bg-accent rounded-full"></div>
            <span className="text-accent font-bold tracking-widest uppercase text-sm">About Founder</span>
          </div>
          
          <h1 className="text-3xl md:text-5xl font-bold text-heads font-Philosopher mb-8 leading-tight">
            पं. महेश दास <br />
            <span className="text-2xl md:text-3xl text-heads/70">( Pt. Mahesh Das )</span>
          </h1>
          
          <p className="text-lg leading-relaxed text-heads/80 mb-6 font-medium text-justify">
            दास का जन्म उत्तरप्रदेश के जिला हापुड़ के ग्राम शिव नगरी बागड़पुर
            में एक ब्राह्मण परिवार में दिन रविवार १४ जून १९८७ को प्रातःकाल
            हुआ। दास की माता का नाम ओमवती देवी तथा पिता का नाम श्री देवेन्द्र
            प्रशाद शर्मा है। दास की प्रारंभिक शिक्षा अपने ग्राम में ही सरकारी
            प्राईमरी स्कूल में हुई जिसमे उनका नाम महेश शंकर शर्मा लिखा गया।
          </p>
          
          <p className="text-lg leading-relaxed text-heads/80 mb-10 font-medium text-justify">
            दास का पहला एक दिवसीय प्रवचन सर्दीय नवरात्र २०१४ को हनुमान चालीसा
            पर नील कंठ महादेव मंदिर बिशनपुरा नॉएडा में हुआ इसी क्रम में वैदिक
            सनातन भक्ति का प्रचार परशार करने लगा परन्तु किसी से भी आज तक एक भी
            रुपया पैसा स्वीकार नहीं किया।
          </p>
          
          <div>
            <Link
              to="/about"
              className="inline-flex items-center justify-center font-Philosopher text-white bg-gradient-to-r from-main to-accent hover:from-mainDark hover:to-accent font-bold rounded-full text-base px-6 py-2.5 transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-1"
            >
              Know More
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
